module.exports = __webpack_public_path__ + "static/media/148-madeira.aabb7340.svg";